import moment from "moment";
import React, { useEffect, useState } from "react";
import { PmsGridSort } from "../../Util/PmsHelper";
import MaterialDataGrid from "../Common/MaterialDataGrid";

export default function EdenWbWebScheduled({ tableData, j47WebSchedLog }) {
  const [rowData, setRowData] = useState([]);
  const [webSchedCount, setWebSchedCount] = useState(0);
  const tableColumn = [
    {
      field: "count",
      headerName: "Count in last 36 hours",
      width: 230,
      type: "number",
    },
    {
      field: "result",
      headerName: "Result",
      width: 350,
      sortComparator: PmsGridSort,
    },
  ];

  useEffect(() => {
    if (j47WebSchedLog.length === 0) return setWebSchedCount(0);

    const data = [];
    
    j47WebSchedLog.forEach((n, i) => {
      const { logTime, apptKey } = n;
      if (logTime === undefined || null) return;

      if (apptKey > 0)
        return data.push({
          ...n,
          id: i,
        });
    });

    setWebSchedCount(data.length);
  }, [j47WebSchedLog]);

  useEffect(() => {
    if (tableData.length === 0) return setRowData([]);

    const data = [];

    tableData.forEach((n, i) => {
      const { lastModifiedDate, createdDate } = n;
      if (lastModifiedDate === undefined || null) return;

      return data.push({
        ...n,
        id: i
      });
    });

    var groupAndGetCount = data.reduce((p, c) => {
      var name = c.result;
      if (!p.hasOwnProperty(name)) {
        p[name] = 0;
      }
      p[name]++;
      return p;
    }, {});

    var grouped = Object.keys(groupAndGetCount).map((k, i) => {
      return { result: k, count: groupAndGetCount[k], id: i };
    });

    setRowData(grouped);
  }, [tableData]);

  return (
    <>
      <label>Web Scheduled Appt Count in last 36 hours: {webSchedCount}</label>
      <MaterialDataGrid
        tableHeight={250}
        tableColumns={tableColumn}
        tableData={rowData}
        onSelectedRow={undefined}
      />
    </>
  );
}
